<template>
    <z-page class="product">
        <div class="title">产品信息</div>
        <z-scrollDiv v-loading='loading' class="scroll-wrap">
            <div v-if="data_list.length<=0" style="text-align:center;">暂无数据</div>
            <product @resetopen='resetopen' v-for="(item,index) in data_list" :key="index" :data_list="item"></product>
        </z-scrollDiv>

        <!-- <warnPop v-model="pop_flag"></warnPop> -->
        <z-windowPop 
            btnClass="danger"
            savetext="重置"
            :btnshow="true"
            title="提示信息"
            @confirm="$func.shake(reset)"
            width='454px'
            v-model="pop_flag">
            <div class="reset">
                <img src="~@/assets/img/warn_icon.svg">
                <div>是否重置 App ID 和 App Secret？</div>
            </div>
        </z-windowPop>
    </z-page>
</template>

<script>

import product from "./product-item.vue"
export default {
    components:{
        product,
    },

    data(){
        return {
            loading:false,
            pop_flag:false,
            data_list:[],
            emitdata:''
        }
    },

    created(){
        this.getdata();
    },

    methods:{
        // 重置
        reset(){
            this.loading=true;
            let url=`/api/supplier/app/renew`
            this.$http.post(url,{},{
                params:{
                    service_id:this.emitdata.ecsProduct.kfProductKey,
                    product_id:this.emitdata.ecsProduct.id
                }
            })
            .then(res=>{
                if(res.code=='200'){
                    this.successTip('重置成功!')
                }else{
                    this.errorTip('重置失败!')
                }
                this.getdata()
                this.loading=false;
            })
            this.pop_flag=false;
        },
        resetopen(value){
            this.emitdata=value;
            this.pop_flag=true;
        },
        // 根据条件调用接口
        getdata(){
            this.loading=true;
            this.$store.dispatch("product")
            .then(res=>{
                this.data_list=res                
                this.loading=false;
            })
            .catch((err)=>{
                this.loading=false;
            })
        }
    }
}
</script>

<style lang="less" scoped>
    .title{
        line-height: 20px;
        padding: @g_padd;
    }
    .scroll-wrap{
        min-height: 300px;
        height:calc(~"100% - 20px - 2*@{g_padd}");
        padding-top: 2px;
    }

    // 重置弹窗
    @img_w:30px;
    .reset{
        color:#595959;
        padding-left:@img_w + 16px;
        position: relative;
        margin: 30px 0 20px 40px;
        img{
            position: absolute;
            left:0;
            top:50%;
            transform: translateY(-50%);
        }
    }
</style>
